import { Toaster } from "react-hot-toast";
import { Outlet } from "react-router-dom";

/**
 * The common layout across every page in the webapp
 * (Right now only used to provide toast messages)
 */
const GlobalLayout = () => {
  return (
    <>
      <Toaster containerStyle={{ zIndex: 999999 }} toastOptions={{ style: { zIndex: 999999 } }} />
      <Outlet />
    </>
  );
};

export default GlobalLayout;
